import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil, combineLatest } from 'rxjs';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CommonService, } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ContentService } from '../../services/content.service';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { distinctUntilChanged } from 'rxjs/operators';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { CustomPattern } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { environment } from 'src/environments/environment';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
@Component({
  selector: 'app-emergerency-contect-form',
  templateUrl: './emergerency-contect-form.component.html',
  styleUrls: ['./emergerency-contect-form.component.scss'],
  imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatSuffix, MatButton, MatProgressSpinner]
})
export class EmergerencyContectFormComponent implements OnInit {
  EmergencyContactForm: FormGroup;
  initialFormValue: any;
  countryCodes: string[] = ['+91', '+1', '+44', '+61', '+971'];
  newCustomCountries: any[] = [];
  userId: string = '';
  guid: string = '';
  userData: any[] = [];
  editpersonal: boolean = false;
  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }
  firstname!: string;
  lastname: string = '';
  hasEmployeeData: boolean = false;
  noDataPersonalInfo!: boolean;
  content: any;
  companySettingDetails: any = {};
  // isProfileViewRestricted: boolean = false;
  private destroy$ = new Subject<void>();
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  constructor(private fb: FormBuilder, private _CamApiService: CamService, private cdr: ChangeDetectorRef, public _CommonService: CommonService, private _ToastrApiService: ToastrApiService, private _ApiService: ApiService, private _CryptoService: CryptoService, private contentService: ContentService, private readonly dictionaryContentService: DisctionaryContent, private readonly travelerManagement: TravelerManagement) {
    this.EmergencyContactForm = this.fb.group({
      contactName: [''],
      relationWithUser: [''],
      emergencyPhoneNumber: ['', [Validators.minLength(8), Validators.maxLength(12)]],
      emergencyCountryCode: [null],
      altCountryCode: [null],
      altEmergencyPhoneNumber: ['', [Validators.minLength(8), Validators.maxLength(12)]],
      queryNo: 16,
      login_name: `${_CryptoService.getValueFromKey('USERFNAME') as string} ${_CryptoService.getValueFromKey('USERLNAME') as string}`,
      branchId: 753755,
      guid: this._ApiService.getSession('guid')
    });
  }

  private setupConditionalValidators(): void {
    this.EmergencyContactForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateNameAndRelationValidators();
        // this.updateEmergencyPhoneValidators();
        // this.updateAltEmergencyPhoneValidators();
      });

    this.updateNameAndRelationValidators();
    // this.updateEmergencyPhoneValidators();
    // this.updateAltEmergencyPhoneValidators();
  }

  private updateNameAndRelationValidators(): void {
  const contactControl = this.getFormControl('contactName');
  const relationControl = this.getFormControl('relationWithUser');

  const hasContact =
    !!contactControl?.value &&
    contactControl.value.toString().trim().length > 0;

  const hasRelation =
    !!relationControl?.value &&
    relationControl.value.toString().trim().length > 0;

  const shouldRequire = hasContact || hasRelation;

  if (shouldRequire) {

    contactControl.setValidators([
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(50)
    ]);

    relationControl.setValidators([
      Validators.required,
      Validators.pattern(CustomPattern.ONLY_ALPHA),
      Validators.minLength(3),
      Validators.maxLength(50)
    ]);

    // Contact name entered but relation is empty
    if (hasContact && !hasRelation) {
      relationControl.markAsTouched();
    }

    // Relation entered but contact name is empty
    if (hasRelation && !hasContact) {
      contactControl.markAsTouched();
    }

  } else {

    contactControl.clearValidators();
    relationControl.clearValidators();

  }

  contactControl.updateValueAndValidity({
    emitEvent: false
  });

  relationControl.updateValueAndValidity({
    emitEvent: false
  });
}

  private updateEmergencyPhoneValidators(): void {
    const codeControl = this.getFormControl('emergencyCountryCode');
    const phoneControl = this.getFormControl('emergencyPhoneNumber');

    const hasCode = !!codeControl?.value;
    const hasPhone =
      !!phoneControl?.value && phoneControl.value.toString().trim().length > 0;

    const shouldRequire = hasCode || hasPhone;

    if (shouldRequire) {
      codeControl.setValidators([Validators.required]);
      phoneControl.setValidators([
        Validators.required,
        Validators.pattern(CustomPattern.ONLY_10_DIGITS),
        Validators.pattern(CustomPattern.ONLY_NUMBERS),
      ]);
    } else {
      codeControl.clearValidators();
      phoneControl.clearValidators();
    }

    codeControl.updateValueAndValidity({ emitEvent: false });
    phoneControl.updateValueAndValidity({ emitEvent: false });
  }

  private updateAltEmergencyPhoneValidators(): void {
    const codeControl = this.getFormControl('altCountryCode');
    const phoneControl = this.getFormControl('altEmergencyPhoneNumber');

    const hasCode = !!codeControl?.value;
    const hasPhone =
      !!phoneControl?.value && phoneControl.value.toString().trim().length > 0;

    const shouldRequire = hasCode || hasPhone;

    if (shouldRequire) {
      codeControl.setValidators([Validators.required]);
      phoneControl.setValidators([
        Validators.required,
        Validators.pattern(CustomPattern.ONLY_10_DIGITS),
        Validators.pattern(CustomPattern.ONLY_NUMBERS),
      ]);
    } else {
      codeControl.clearValidators();
      phoneControl.clearValidators();
    }

    codeControl.updateValueAndValidity({ emitEvent: false });
    phoneControl.updateValueAndValidity({ emitEvent: false });
  }

  getFormControl(controlName: string): FormControl {
    return this.EmergencyContactForm.get(controlName) as FormControl;
  }
  ngOnInit(): void {

    combineLatest({
      content: this.contentService.content$, dictionary: this.dictionaryContentService.content$
    }).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = {
        ...res.content,
        dictionary: res.dictionary
      }
    });

    this.userId = sessionStorage.getItem('userId') || '';
    this.guid = sessionStorage.getItem('guid') || '';
    // const stored = localStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS) ?? sessionStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS);
    // this.companySettingDetails = stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    // const travelerGUID = localStorage.getItem('travelerGUID')?.toLowerCase();
    // const userGuid = localStorage.getItem('userGuid')?.toLowerCase();
    // this.isProfileViewRestricted = this.companySettingDetails?.restrictAmendmentInTravelerProfile && (travelerGUID !== userGuid);
    const hasValues = this.checkEmergencyContactValues();

    console.log('Has Emergency Contact Values:', hasValues);
    // if (this.isProfileViewRestricted) {
    //   this.EmergencyContactForm.disable();
    // }
    this.firstname = this._CryptoService.getValueFromKey('USERFNAME') as string;
    this.lastname = this._CryptoService.getValueFromKey('USERLNAME') as string;

    if (this.userId && this.guid) {
      this.editpersonal = true;
      this._CamApiService.GetUserExecutive(this.userId, this.guid).then((response: any) => {
        if (response?.status === 'Success') {
          this.userData = response.data.SubagentUser;
          this.prefillForm(this.userData);
        }
      }).catch((error: any) => { console.error('Error fetching user data:', error); });
    } else {
      this.editpersonal = false;
    }


    this._ApiService.getCountriesData().then(($res) => {
      this.newCustomCountries = this._CommonService.groupCountriesFilter($res)
    }).catch(($err) => { });


    this.noDataPersonalInfo = this._CommonService.getData('camSidebar')
    this.setupConditionalValidators();

    // Emergency
    this.EmergencyContactForm.get('emergencyCountryCode')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updatePhoneValidatorByControl('emergencyCountryCode', 'emergencyPhoneNumber');
      });

    this.EmergencyContactForm.get('emergencyPhoneNumber')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updatePhoneValidatorByControl('emergencyCountryCode', 'emergencyPhoneNumber');
      });

    // Alternate
    this.EmergencyContactForm.get('altCountryCode')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updatePhoneValidatorByControl('altCountryCode', 'altEmergencyPhoneNumber');
      });

    this.EmergencyContactForm.get('altEmergencyPhoneNumber')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updatePhoneValidatorByControl('altCountryCode', 'altEmergencyPhoneNumber');
      });

  }
  Editpersonal() {
    this.editpersonal = true;
    this.Loader.isEditableClicked = false;
    this.EmergencyContactForm.enable();
  }

  getImageUrl(path: string): string {
    if (!path) return '';

    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');

    return `${base}/${cleanPath}`;
  }
  prefillForm(userData: any[]): void {
    if (userData && userData.length > 0) {
      const emergencyPhone = this.userData[0]?.Emergency_PhoneNo;
      let emergencyCountryCode = '';
      let emergencyPhoneNumber = '';
      if (typeof emergencyPhone === 'string' && emergencyPhone.includes('-')) {
        const splitPhone = emergencyPhone.split('-');
        emergencyCountryCode = splitPhone[0] ?? '';
        emergencyPhoneNumber = splitPhone[1] ?? '';
      }

      const alternateNumber = this.userData[0]?.Alternate_Number;
      let altCountryCode = '';
      let altEmergencyPhoneNumber = '';
      if (typeof alternateNumber === 'string' && alternateNumber.includes('-')) {
        const splitAlt = alternateNumber.split('-');
        altCountryCode = splitAlt[0] ?? '';
        altEmergencyPhoneNumber = splitAlt[1] ?? '';
      }

      this.EmergencyContactForm.patchValue({
        contactName: this.returnValueIfValid(userData[0]?.Emergency_ContactName) ?? '',
        relationWithUser: typeof userData[0]?.Emergency_ContactRelation === 'string' ? this.returnValueIfValid(userData[0].Emergency_ContactRelation) : '',
        emergencyCountryCode: this.returnValueIfValid(emergencyCountryCode) || null,
        emergencyPhoneNumber: this.returnValueIfValid(emergencyPhoneNumber) || '',
        altCountryCode: this.returnValueIfValid(altCountryCode) || null,
        altEmergencyPhoneNumber: this.returnValueIfValid(altEmergencyPhoneNumber) || '',
        login_name: (this.userData[0]?.login_Name && this.userData[0].login_Name.trim().length > 0)
          ? this.userData[0].login_Name
          : (this.userData[0]?.email_Address || `${this.firstname} ${this.lastname}`),
        branchId: this.userData[0]?.SA_Branch_ID
      });
      this.initialFormValue = this.EmergencyContactForm.value
      this.hasEmployeeData = this.checkEmergencyContactValues();//check value is in form control or not
      if (this.hasEmployeeData) {
        this.Loader.isEditableClicked = true;
        this.EmergencyContactForm.disable();
      } else {
        this.Loader.isEditableClicked = false;
        this.EmergencyContactForm.enable();
      }
      this.cdr.detectChanges();
    } else {
      this.EmergencyContactForm.reset({
        contactName: '',
        relationWithUser: '',
        emergencyPhoneNumber: '',
        emergencyCountryCode: '',
        altCountryCode: '',
        altEmergencyPhoneNumber: '',
        queryNo: 16,
        login_name: `${this.firstname} ${this.lastname}`,
        branchId: 753755,
        guid: this._ApiService.getSession('guid')
      })
      this.Loader.isEditableClicked = false;
      this.EmergencyContactForm.enable();
      Object.keys(this.EmergencyContactForm.controls).forEach(controlName => {
        const control = this.EmergencyContactForm.get(controlName);
        if (control) {
          control.markAsPristine();
          control.markAsUntouched();
          control.setErrors(null);
        }
      });
      this.EmergencyContactForm.markAsPristine();
      this.EmergencyContactForm.markAsUntouched();
    }
  }

  private buildPhoneWithCode(code: any, phone: any): string {
    const hasCode = !!code;
    const hasPhone = !!phone && phone.toString().trim().length > 0;

    if (!hasCode && !hasPhone) {
      return '';
    }

    return `${code}-${phone}`;
  }

  saveEmergencyContact() {
    // GTM Event Call
    this.travelerManagement.traveler_detail_click('Save');
    this.Loader.isSpinner = true;
    let copy = JSON.parse(JSON.stringify(this.EmergencyContactForm.value));

    copy.emergencyPhoneNumber = this.buildPhoneWithCode(
      copy.emergencyCountryCode,
      copy.emergencyPhoneNumber
    );
    copy.altEmergencyPhoneNumber = this.buildPhoneWithCode(
      copy.altCountryCode,
      copy.altEmergencyPhoneNumber
    );

    delete copy.emergencyCountryCode;
    delete copy.altCountryCode;

    this._CamApiService.UpdateUserExecutive(this.userId, this.userData[0].SA_User_ID, copy).then(($res: any) => {
      setTimeout(() => {
        this.Loader.isSpinner = false;
        this.Loader.isEditableClicked = true;
        this.EmergencyContactForm.disable();
        this._ToastrApiService.show('success', $res.message);
        this.ngOnInit();
      }, 2000)
    })
  }
  Cancel() {
    // GTM Event Call
    this.travelerManagement.traveler_detail_click('Cancel');
    if (this.hasEmployeeData) {
      this.editpersonal = false;
      this.Loader.isEditableClicked = true; // This should be true to disable the input
      this.prefillForm(this.userData); // Re-prefill with the original data
      this.EmergencyContactForm.markAsPristine(); // Crucial: Resets form state to pristine
      this.EmergencyContactForm.markAsUntouched(); // Optional: Resets touched state
    }
    else {
      this.Loader.isEditableClicked = false;
      this.prefillForm([]);
    }

  }

  emergengyPhoneValidation(event: KeyboardEvent) {
    const allowedRegex = /^[a-zA-Z0-9 +]$/
    if (!allowedRegex.test(event.key)) {
      event.preventDefault();
    }
  }
  returnValueIfValid(value: any) {
    if (value !== null &&
      value !== undefined &&
      value !== '' &&
      !(typeof value === 'object' && Object.keys(value).length === 0)) {
      return value;
    } else {
      return '';
    }
  }


  checkEmergencyContactValues(): boolean {
    const controls = [
      'contactName',
      'relationWithUser',
      'emergencyPhoneNumber',
      'emergencyCountryCode',
      'altCountryCode',
      'altEmergencyPhoneNumber'
    ];

    return controls.some(controlName => {
      const value = this.EmergencyContactForm.get(controlName)?.value;
      return value !== null && value !== undefined && value.toString().trim() !== '';
    });
  }



  updatePhoneValidatorByControl(
  countryControlName: string,
  phoneControlName: string
) {
  const phoneControl = this.EmergencyContactForm.get(phoneControlName);
  const codeControl = this.EmergencyContactForm.get(countryControlName);

  const hasPhone =
    !!phoneControl?.value &&
    phoneControl.value.toString().trim().length > 0;

  const hasCountry = !!codeControl?.value;

  if (hasCountry || hasPhone) {

    phoneControl?.setValidators([
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(12)
    ]);

    codeControl?.setValidators([
      Validators.required
    ]);

    // Country code selected but phone number empty
    if (hasCountry && !hasPhone) {
      phoneControl?.markAsTouched();
    }

  } else {

    phoneControl?.setValidators([
      Validators.minLength(8),
      Validators.maxLength(12)
    ]);

    codeControl?.clearValidators();

  }

  phoneControl?.updateValueAndValidity({
    emitEvent: false
  });

  codeControl?.updateValueAndValidity({
    emitEvent: false
  });
}
}
